import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { WithdrawalReasonOption, WithdrawalSteps, WithdrawType } from '@inyova/models';

@Component({
  selector: 'app-withdrawal-reasons',
  templateUrl: './withdrawal-reasons.component.html',
  styleUrls: ['./withdrawal-reasons.component.scss'],
  standalone: false
})
export class WithdrawalReasonsComponent implements OnInit {
  @Input() isMobileApp: boolean;
  @Input() reasonOptions: WithdrawalReasonOption[];
  @Input() parent: FormGroup;
  @Input() withdrawalType: WithdrawType;
  @Output() prevStep: EventEmitter<void> = new EventEmitter<void>();
  @Output() nextStep: EventEmitter<WithdrawalSteps> = new EventEmitter<WithdrawalSteps>();
  @Output() trackActivity: EventEmitter<string> = new EventEmitter<string>();
  reasonOptionsIds: number[];

  get reasonsControl(): AbstractControl {
    return this.parent.get('reasons');
  }

  ngOnInit(): void {
    this.reasonOptionsIds = this.reasonOptions.map((reason) => reason.id);
  }

  isSelected(optionId: number) {
    return (this.reasonsControl.value as number[]).includes(optionId);
  }

  onCheckboxChange(optionId: number, optionText: string) {
    const selectedReasons = this.reasonsControl.value as number[];
    const index = selectedReasons.indexOf(optionId);
    let newSelection = [];

    if (index > -1) {
      newSelection = [...selectedReasons.slice(0, index), ...selectedReasons.slice(index + 1)];
      this.trackActivity.emit(`[Button] New Withdrawal: Deselect reason - ${optionText}`);
    } else {
      newSelection = [...selectedReasons, optionId].sort((a, b) => this.reasonOptionsIds.indexOf(a) - this.reasonOptionsIds.indexOf(b));
      this.trackActivity.emit(`[Button] New Withdrawal: Select reason - ${optionText}`);
    }
    this.reasonsControl.setValue(newSelection);
    this.reasonsControl.updateValueAndValidity();
  }

  onContinue() {
    this.nextStep.emit(this.withdrawalType === WithdrawType.FULL ? WithdrawalSteps.CLOSE : WithdrawalSteps.SUMMARY);
  }

  onBack() {
    this.prevStep.emit();
  }
}
